import angulartics from 'angulartics';

/**
 * @ngdoc service
 * @name eventix.common.services.GoogleTagManagerProvider
 * @description
 * A manager for Google Tag Manager, see service docs
 */
export default angular.module('eventix.common.services.googleTagManager',[angulartics])
    /**
     * @ngdoc service
     * @name eventix.common.services.GoogleTagManager
     * @description
     * A manager for Google Tag Manager.
     *
     * Relies on `angulartics` for the integration with the app.
     *
     * Virtual pageviews are submitted to GTM with following event schema
     *
     * ```
     * {
     *     "event": "content-view",
     *     "content-name": "/path/of/route"
     * }
     * ```
     *
     * Custom events are submitted with the following schema, mirroring Google Analytics terminology
     *
     * ```
     * {
     *     "event": eventName || "interaction",
     *     "action": event.action,
     *     "category": event.category,
     *     "label": event.label,
     *     "value": event.value,
     *     "content-name": "/path/of/route",
     *     "userId": "uuid"
     *     "interaction-type": event.noninteraction // Honestly no idea?
     * }
     * ```
     *
     * Custom events can be sent using `$angulartics.eventTrack()` service or using the `analyticsOn` directive. UserID
     * can be set using `$angulartics.setUsername(id, propertyObject)`. For these I'll refer you to
     * [their reference](http://angulartics.github.io)
     */
    .provider('GoogleTagManager', function($analyticsProvider, LibraryLoaderProvider) {
        var codes = [];
        var containers = [];
        var lastPage = '/';
        var user = null;

        $analyticsProvider.registerPageTrack(function(path) {
            lastPage = path;
            _.forEach(containers, c => {
                var container = _.isArray(window[c]) ? window[c] : [];
                container.push({
                    event: 'content-view',
                    'content-name': path,
                    userId: _.get(user, 'userId')
                });
            });
        });

        $analyticsProvider.registerEventTrack(function(eventName, properties = {}) {
            _.forEach(containers, c => {
                var container = _.isArray(window[c]) ? window[c] : [];
                var payload = {};
                if(eventName === 'ecommerce')
                    payload = properties;
                else {
                    payload = _.omitBy({
                        event: _.isEmpty(eventName) ?  'interaction' : eventName,
                        action: properties.action,
                        value: properties.value,
                        category: properties.category,
                        label: properties.label,
                        userId: _.get(user, 'userId'),
                        'content-name': lastPage,
                        'interaction-type': properties.noninteraction
                    }, _.isNil);
                }
                container.push(payload);
            });
        });

        $analyticsProvider.registerSetUsername(function(userId, properties = {}) {
            user = {
                userId: userId,
                properties: properties
            };
        });


        function addContainer(code, containerName = 'dataLayer') {
            if(_.includes(codes, code)) {
                console.warn('GTM container already exists'); // eslint-disable-line
                return;
            }
            var insertBefore = document.getElementsByTagName('script')[0];
            if(!_.includes(containers, containerName))
                containers.push(containerName);
            window[containerName] = window[containerName] || [];
            window[containerName].push({
                'gtm.start': new Date().getTime(),
                event: 'gtm.js'
            });
            let dl = containerName !== 'dataLayer' ? '&l=' + containerName : '';
            let url = '//www.googletagmanager.com/gtm.js?id=' + code + dl;
            LibraryLoaderProvider.load(url);
            codes.push(code);
        }

        /**
         * @ngdoc method
         * @name eventix.common.services.GoogleTagManagerProvider#addContainer
         * @methodOf eventix.common.services.GoogleTagManagerProvider
         * @description
         * Add a GTM container
         *
         * @param {String} code E.g.: `GTM-XXXX`
         * @param {String} [containerName=dataLayer]
         * Name for container, multiple codes can (supposedly) share a container
         */
        this.addContainer = addContainer;
        this.$get = function() {
            /**
             * @ngdoc method
             * @name eventix.common.services.GoogleTagManager#addContainer
             * @methodOf eventix.common.services.GoogleTagManager
             * @description
             * Add a GTM container
             *
             * @param {String} code E.g.: `GTM-XXXX`
             * @param {String} [containerName=dataLayer]
             * Name for container, multiple codes can (supposedly) share a container
             */
            return {
                addContainer: addContainer
            };
        };
    }).name;
